import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {ApiUrl} from '@emm/core/util/api-url.token';
import {ItemTypeClass} from '@emm/core/models/item-type-class.model';
import {standardRetry} from '@emm/core/util/rx.util';


@Injectable({
    providedIn: 'root',
})
export class ItemTypeClassService {

    constructor(@Inject(ApiUrl) private apiUrl: string, private http: HttpClient) {}

    getAllItemTypeClasses(): Observable<ItemTypeClass[]> {
        return this.http.get<ItemTypeClass[]>(this.apiUrl + '/item-types/item-type-class').pipe(
            map((response) => response['itemTypeClasses']),
            standardRetry()
        );
    }
}
